/**
 * Main App Component
 *
 * PostHog is initialized in `main.tsx` before render so render-time errors
 * and the initial $pageview are captured.
 */

import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { ErrorBoundary } from "./components/ui/error-boundary";
import { StepUpOtpDialog } from "./features/auth/components/step-up-otp-dialog";
import { useAuthStore } from "./features/auth/store/auth.store";
import { useRefreshUserOnVisible } from "./hooks/use-refresh-user-on-visible";
import { useSavedLanguage } from "./hooks/use-saved-language";
import { useSessionReplay } from "./hooks/use-session-replay";
import { useThemeMode } from "./hooks/use-theme-mode";
import { router } from "./routes";

function App() {
	const refreshUser = useAuthStore((s) => s.refreshUser);

	useEffect(() => {
		refreshUser();
	}, [refreshUser]);

	useRefreshUserOnVisible();

	useSavedLanguage();

	// Starts or stops replay as auth, the opt-out and the flag change.
	useSessionReplay();

	// sonner draws its toasts with its own palette, so pass the mode on screen.
	const { resolved: themeMode } = useThemeMode();

	return (
		<ErrorBoundary>
			<RouterProvider router={router} />
			<StepUpOtpDialog />
			<Toaster position="top-right" richColors closeButton theme={themeMode} />
		</ErrorBoundary>
	);
}

export default App;
